const Paths = {
  Login: "/login",
  ForgotPassword: "/ForgotPassword",
  ResetPassword: "/ResetPassword",
  TwoFAuth: "/TwoFAuth",
  Help: "/Help",
  Error: "/Error",
  Reports: "/reports",
  ReportBreach: "/report-breach",
  StorageSearch: "/storage-search",
  AdminHomePage: "/admin/accounts",
};

export default Paths;
